import { Link } from "gatsby";
import React from "react";
import { freelanceQualificationsData } from "./CareersConfig";

function ThirdCareers() {
  return (
    <div className="bg-midBlue text-white font-sans pb-[84px] pt-[32px]">
      <div className="w-11/12 sm:w-10/12 xl:w-8/12 max-w-6xl mx-auto text-24 leading-7">
        <div className="sm:w-11/12 mx-auto">
          <h2 className="text-40 leading-[50px] mb-10 text-center font-medium">
            Freelance Translators Wanted!
          </h2>
          <p className="mb-4 font-light">
            We are constantly looking to expand our team of professional and
            experienced freelance translators, interpreters, editors and content
            writers. If you are interested in a flexible collaboration with
            varied and interesting assignments, then you might be the one we're
            looking for.
          </p>
        </div>
      </div>
      <div className="w-11/12 sm:w-10/12 xl:w-9/12 max-w-6xl mx-auto text-24 pt-[44px]">
        <p className="text-24 left-7 mb-10 pt-[52px]">Qualifications |</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7 text-[21px] font-light leading-normal">
          {freelanceQualificationsData &&
            freelanceQualificationsData.map(({ text }, i) => {
              return (
                <div
                  className="bg-black rounded-lg shadow-lg px-5 py-3 flex items-center justify-center"
                  key={i}
                >
                  <p className="text-center">{text}</p>
                </div>
              );
            })}
        </div>
        <div className="grid place-items-center pt-[84px]">
          <a
            href="https://www.tomedes.com/user/provider/createaccount"
            className="bg-lightBlue inline-flex items-center gap-4 rounded-md py-4 px-6"
            target="_blank"
          >
            <img
              src="https://skins.tomedes.com/frontend/images/careers_icons/registration.svg"
              alt=""
              className="w-16"
            />
            <span className="text-24 text-white font-light">
              Register as a translator
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ThirdCareers;
